<template>
<div :class="show_poster ? 'page page_artDetail page_limit' : 'page page_artDetail'">
    <div class="userInfo">
        <!-- 个人信息 -->
        <div class="user">
            <div class="top">
                <div class="user_info">
                    <div class="thumb">
                        <van-image class="thumb" fit="cover" :src="info.thumb ? ($publicData.withHttpStart(info.thumb) ? info.thumb :imageUrl+info.thumb) : $publicData.defaultTouxiang" :show-error="false" :show-loading="false" />
                    </div>
                    <span :class="register_status == 1 ? 'user_name zhuced' : 'user_name unzhuce'">{{ info.legal_person }}</span>
                </div>
                <!-- <div class="zhuli">助力</div> -->
				<div class="zhuli" v-if="posterUrl" @click="show_poster = true">分享</div>
            </div>
            <div class="info">
                <span class="user_name">{{ info.nickname }}</span>
                <span class="user_tag">{{ info.auth_company }}</span>
            </div>
            <!-- 线上结构 -->
            <div class="user_address" v-if="info.address">{{ info.address }}</div>
            <!-- 测试结构 -->
            <!-- <div class="user_address">
                <div class="text" v-if="livesInfo.tradesman">{{ livesInfo.tradesman.address }}</div>
            </div> -->
            <!-- <div class="acticons">
                <div class="action" @click="attentionClickFun">{{info.is_attention==1?'已关注':'关注'}}</div>
                <div class="action" @click="serveClick">私信</div>
            </div> -->
        </div>
    </div>
    <div class="yuekan_con">
        <div class="con_title" v-if="info.info">
            <span class="title">简介</span>
        </div>
        <div class="jieshao" v-html="info.info"></div>
        <div class="con_title" v-if="newsList && newsList.length > 0">
            <span class="title">资讯</span>
        </div>
        <div class="yuekan" v-if="newsList && newsList.length > 0">
            <ul class="type_three_list clearfix">
                <li class="item" v-for="news in newsList" :key="news.id" >
                    <div class="news" @click="toNewsDetail(news)">
                        {{ news.title }}
                    </div>        
                </li>
            </ul>
        </div>
    </div>
    <div class="yuekan_con">
        
    </div>
	<!-- 分享海报 -->
	<van-overlay :show="show_poster" @click="show_poster = false" class="" />
	<div class="poster" v-if="show_poster">
		<img :src="imageUrl + posterUrl" alt="" class="posterTu">
	</div>
	<div class="share_tips" v-if="show_poster">长按保存图片</div>
	<!-- 入驻 -->
	<div class="ruzhu" v-if="register_status != 1" @click="toRegister">去入驻</div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
            type: this.$route.query.type,
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
            token: null,
            tradesmanId: this.$route.query.tradesmanId,
            active: this.$route.query.type ? this.$route.query.type : 'a',
            goodsList: [],  // 产品列表
            livesInfo: [],  // 活动列表
            videoInfo: [],  // 视频列表
            livingInfo: null,   // 直播
            newsList: [],
            imageUrl: this.$publicData.uploadImage,
            pages: {
                page: 1,
                size: 10
            },
            loading_goods: true, // 配置immediate-check="false"时, 初始值为true
            finished_goods: false,
            loading_live: true,
            finished_live: false,
			shareConfig: null, // 分享的相关配置
			show_poster: false, // 海报弹层
			posterUrl: null, // 分享图链接
			register_status: this.$route.query.register_status ? this.$route.query.register_status : 1, // 入驻状态 1 已入驻 0 未入驻
			is_tradesman: null // 用户是否为匠人角色
        };
    },
    created: function () {
        // if (this.type == 'b') {
        //     this.active = 'b'
        // }
        console.log('this.active', this.active)
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                'data': {
                    'naviTitle': '匠人详情',
                    levitate: true,
                    showStatusBar: true,
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            }
            //加载用户信息
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    
                }
                this.getData()
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
		}
		
    },
    mounted: function () {

    },
    methods: {
        getData() {
            this.getDetail()
            this.getHistoryList()
        },
        getDetail() {
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId
            }
            this.$api.tradesman.detail(param).then(res => {
                if (res.code == 200) {
                    var info = res.result
					this.info = info
					this.register_status = res.result.register_status
					// 未入驻,先判断用户是否为匠人,非匠人方可让他去入驻
					if(this.register_status != 1){
						this.getUserInfo()
					}
                    // 调微信分享参数
					this.getShareData()
					// 获取分享图片
					this.getSharePoster()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        getHistoryList() {
            var that = this
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId,
                page: 1,
			    size: 100
            }
            this.$api.tradesman.history(param).then(res => {
                if (res.code == 200) {
                    that.newsList = res.result.list
                } else {
                    this.$toast(res.message)
                }
            })
        },
        toNewsDetail(news) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    'data': {
                        'url': news.link_url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                window.open(news.link_url)
            }
        },
        serveClick() {
			var that = this;
			// 未入驻匠人不支持发私信
			if(that.register_status != 1){
				that.$toast('该匠人未入驻')
				return
			}
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo",memberParams,(data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        var params = {
                            token: this.token,
                            uuid: that.info.uuid
                        };
                        that.$api.xiaoxi.userInfo(params).then(res => {
                            if (res.code == 200) {
                                var tradesmanInfo = res.result;
                                // console.log('创建了与匠人的通信')
                                // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                                that.toAppServe(tradesmanInfo);
                            }
                        })
                    }
                });             
            } else {
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                    })
                    return
                }
                this.$router.push({
                    path: '/tradesman/chat',
                    query:{
                        uuid: this.info.uuid 
                    }
                })
                // this.$router.push({
                //     path: '/system/develop'
                // })
            }
        },
        toAppServe(tradesmanInfo) {
            console.log('tradesmanInfo:',tradesmanInfo)
            var params = {
                data: {
                    toId: tradesmanInfo.im_username,
                    conversationId: tradesmanInfo.im_username,
                    toAvator: this.info.thumb,
                    toName: this.info.nickname,
                    toUUID: this.info.uuid,
                    toPhone: tradesmanInfo.tradesmans.data.phone,
                    trandsmanId: tradesmanInfo.tradesmans.id
                },
            }
            this.$bridge.callhandler("sdjy://public/chat",params,(data) => {

            });
        },
		// 关注匠人对app和h5进行判断
		attentionClickFun(){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.attentionClick();
						}
					}
				);
			} else {
				// console.log('对App和H5做判断')
				this.attentionClick();
			}
		},
		// 关注匠人
        attentionClick() {
            var type = 1
            if (this.info.is_attention == 1) {
                type = 2
            }
            var params = {
                token: this.token,
                tradesman_id: this.tradesmanId,
                type: type
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res => {
                if (res.code == 200) {
                    if (this.info.is_attention == 1) {
                        this.$toast('取消关注成功')
                    } else {
                        this.$toast('关注成功')
                    }
                    this.getDetail()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        toInfo() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/info?tradesmanId=' + this.tradesmanId
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/info',
                    query: {
                        tradesmanId: this.tradesmanId
                    }
                })
            }
        },
        toFans() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/fans/index?tradesmanId=' + this.tradesmanId + '&tradesman_uuid=' + this.info.uuid
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/fans/index',
                    query: {
						tradesmanId: this.tradesmanId,
						tradesman_uuid: this.info.uuid
                    }
                })
            }
        },
        toGoodsDetail(goods) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?goodsId=" + goods.good_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/shop/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/shop/detail',
                    query: {
                        goodsId: goods.good_id
                    }
                })
            }
        },
        toLivingDetail(living) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?id=" + living.living_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/zhibo/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: `/zhibo/detail`,
                    query:{id:living.living_id}
                })
            }
            
        },
        goVideoDetail(video) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?id=" + video.id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/video/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: `/video/detail`,
                    query:{id:video.id}
                })
            }
        },
        goLivesDetail(lives) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?id=" + lives.live_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/yuekan/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/yuekan/detail',
                    query: {
                        id: lives.live_id
                    }
                })
            }

        },
        // 切换 
        changeTab(name) {
            console.log('name', name)
            this.pages.page = 1
            if (name == 'a') {
                this.goodsList = []
                this.loading_goods = true;
                this.finished_goods = false;
                this.getGoodsList()
            }
            if (name == 'b') {
                this.livesInfo = []
                this.loading_live = true;
                this.finished_live = false;
                this.getLiveList()
            }
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.info.nickname ? that.info.nickname : that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: that.info.describe ? that.info.describe : '', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.info.thumb ? (that.$publicData.withHttpStart(that.info.thumb) ? that.info.thumb : that.imageUrl+that.info.thumb) : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
		},
		// 获取分享图片 ** 后台返回的
		getSharePoster(){
			var that = this
			var params = {
				id: that.info.uuid,
				type: 2 // 1商品 2匠人 3直播 4约看
			}
			that.$api.common.shareImg(params).then(res=>{
				if(res.code == 200){
					that.posterUrl = res.result
				}else{
                    that.posterUrl = null
					// that.$toast(res.message)
				}
			})
		},
		// 获取用户角色
		getUserInfo(){
			var params = {
                token: this.token,
                is_cloud: 0 // 非云订单
			}
			this.$api.user.index(params).then(res => {
				if (res.code == 200) {
					this.is_tradesman = res.result.info.userrole.is_tradesman
				}
			})
		},
		// 入驻
		toRegister(){
			var that = this
			if(that.is_tradesman){
				that.$toast('您已是匠人,不可重复申请')
				return
			}else{
				that.$router.push({
					path: '/cooperation/transition'
				})
			}
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
